import React from "react";
import { Link } from "react-router-dom";
import { BsTwitterX, BsGithub } from "react-icons/bs";

const Footer = () => {
  return (
    <footer className="bg-white dark:bg-black text-black dark:text-white border-b border-black dark:border-white/30 font-sans uppercase">
      <div className="w-full flex flex-col lg:flex-row border-t border-black dark:border-white/30">
        {/* Brand Block */}
        <div className="w-full lg:w-1/3 lg:border-r border-b lg:border-b-0 border-black dark:border-white/30 p-8 md:p-12 flex flex-col min-h-[200px] md:min-h-[300px]">
          <div>
            <h2 className="text-5xl font-black tracking-tighter leading-[0.85] break-words">
              BLOG SHOG
            </h2>
            <p className="mt-6 text-xs font-mono tracking-widest leading-relaxed max-w-[250px] text-gray-700 dark:text-gray-300">
              EST. 2022
              <br />
              ALL RIGHTS RESERVED
            </p>
          </div>
          <div className="flex gap-4 mt-4">
            <a
              href="https://x.com/imakshit3010"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 border border-black dark:border-white/30 flex items-center justify-center hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors"
            >
              <BsTwitterX className="text-lg" />
            </a>
            <a
              href="https://github.com/Akshit3010"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 border border-black dark:border-white/30 flex items-center justify-center hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors"
            >
              <BsGithub className="text-lg" />
            </a>
          </div>
        </div>

        {/* Links Grid */}
        <div className="w-full lg:w-2/3 flex flex-col sm:flex-row py-4 md:py-12">
          <div className="flex-1 border-b sm:border-b-0 border-black dark:border-white/30 flex flex-col">
            <ul className="flex-1 flex flex-col text-sm list-none font-bold tracking-widest divide-y divide-black/10 dark:divide-white/10 pl-0">
              <li>
                <Link
                  to="/blogs"
                  className="block px-8 py-5 hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors"
                >
                  Digital Archive
                </Link>
              </li>
              <li>
                <Link
                  to="/blogs/create"
                  className="block px-8 py-5 hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors"
                >
                  Initiate Project
                </Link>
              </li>
              <li>
                <Link
                  to="/login"
                  className="block px-8 py-5 hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors"
                >
                  Authorize Identity
                </Link>
              </li>
              <li>
                <Link
                  to="/signup"
                  className="block px-8 py-5 hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors"
                >
                  Register Identity
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
